module.exports = __webpack_public_path__ + "static/office_small_green_hall-f4daaa2e535580379b22fc40a2174e91.jpg";